module.exports = __webpack_public_path__ + "static/media/13.1a74afe4.jpg";